// Body of the Oscar order-pending ("order error") view: the static order-error
// copy block. All copy arrives pre-localized as string props (server-side
// gettext) so fr_CA is preserved — React `t` would always emit English.
import { Immutable } from "immer";
import React from "react";
import { FORM_FIELD_SUBMIT_CLASS_NAME } from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<templates.OrderPendingDocumentTemplate>;

export const OrderPendingBody = (props: IProps): React.JSX.Element => {
    return (
        <div id="thanks" data-number={props.order_number}>
            <div className="order-confirmation__header">
                <h1 className={styles.orderErrorIntroTitle}>
                    {props.intro_title}
                </h1>
                <div className={styles.orderErrorIntroCopy}>
                    <p>{props.intro_line_1}</p>
                    <p>{props.intro_line_2}</p>
                    <p>{props.intro_line_3}</p>
                    <ol>
                        {props.steps.map((step, i) => (
                            <li key={i}>{step}</li>
                        ))}
                    </ol>
                    <p>{props.reassurance}</p>
                </div>
                <div>
                    <p className={styles.orderErrorIntroCopyBold}>
                        {props.contact_line}
                        <br />
                        {props.hours_line}
                    </p>
                </div>
                <div className={styles.orderErrorContinue}>
                    <a href="/">
                        <div
                            className={concatClassNames([
                                "button",
                                FORM_FIELD_SUBMIT_CLASS_NAME,
                            ])}
                        >
                            Shop Now
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};
